// extracted by extract-css-chunks-webpack-plugin
    if(module.hot) {
      // 1697201250387
      var cssReload = require("/home/kusanagi/adop-line-ec_plaisir/b2b/node_modules/extract-css-chunks-webpack-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"reloadAll":true,"hmr":true,"locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  